/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/shad/dialog";
import { textVariants } from "../Text/Text";
import { cn } from "@/lib/utils";
import { useMediaQuery } from "usehooks-ts";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "../shad/drawer";
import { X } from "lucide-react";

interface Props {
  open: boolean;
  setOpen: (val: any) => void;
  children: string | JSX.Element | JSX.Element[];
  size?: "sm" | "md" | "lg" | "xl";
  title?: string;
  description?: string;
  drawerHeight?: string;
  footer?: string | JSX.Element | JSX.Element[];
  setter?: "url" | "state";
  unstyled?: boolean;
  closeIcon?: boolean;
}

export function Modal({
  open,
  children,
  setOpen,
  title,
  description,
  size = "md",
  //   drawerHeight,
  footer,
  setter = "url",
  unstyled = false,
  closeIcon = true,
}: Props) {
  const matches = useMediaQuery("(min-width: 768px)");
  const width = {
    sm: "xl:w-1/4 lg:2/4",
    md: "xl:w-2/6 lg:3/6",
    lg: "lg:w-3/6 md:w-4/6",
    xl: "lg:w-4/6 md:w-5/6",
  };
  const selectedWidth = width[size];

  if (!matches)
    return (
      <Drawer
        shouldScaleBackground
        open={open}
        onOpenChange={
          setter === "url" ? (val) => setOpen(!val) : (val) => setOpen(val)
        }
      >
        {/* <DrawerTrigger asChild>
    {trigger}
</DrawerTrigger> */}
        <DrawerContent className={`max-h-[90vh] dark:bg-grey-800 pb-10`}>
          <DrawerHeader className="text-left">
            <DrawerTitle
              className={textVariants({
                variant: "header",
                case: "capitalize",
                size: "xl",
                font: "semibold",
              })}
            >
              {title}
            </DrawerTitle>
            <DrawerDescription>{description}</DrawerDescription>
          </DrawerHeader>
          <div className="px-4 overflow-y-scroll">{children}</div>
          {footer && <DrawerFooter>{footer}</DrawerFooter>}
        </DrawerContent>
      </Drawer>
    );

  if (!unstyled)
    return (
      <Dialog open={open}>
        <DialogContent className={cn(`${selectedWidth} w-[425px]`)}>
          {closeIcon && (
            <div
              onClick={
                setter === "url" ? (val) => setOpen(val) : () => setOpen(false)
              }
              className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground dark:text-white cursor-pointer"
            >
              <X className="h-4 w-4" />
              <span className="sr-only">Close</span>
            </div>
          )}
          <DialogHeader>
            {title && (
              <DialogTitle className={textVariants({ variant: "header" })}>
                {title}
              </DialogTitle>
            )}
            <DialogDescription>{description}</DialogDescription>
          </DialogHeader>
          {children}
          {footer && <DialogFooter>{footer}</DialogFooter>}
        </DialogContent>
      </Dialog>
    );

  return (
    <Dialog open={open}>
      <DialogContent className={cn(`${selectedWidth} w-[425px] p-0`)}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
